var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidentSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.25C11.5 8.63071 10.3807 9.75 9 9.75C7.61929 9.75 6.5 8.63071 6.5 7.25C6.5 5.86929 7.61929 4.75 9 4.75C10.3807 4.75 11.5 5.86929 11.5 7.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 18.5V17.4C4.25 14.74 6.39 12.6 9.05 12.6C11.71 12.6 13.85 14.74 13.85 17.4V18.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 16.35C19.4 17.675 18.325 18.75 17 18.75C15.675 18.75 14.6 17.675 14.6 16.35C14.6 15.025 15.675 13.95 17 13.95C18.325 13.95 19.4 15.025 19.4 16.35Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.85V12.75M17 19.95V20.85M13.5 16.35H14.4M19.6 16.35H20.5M14.55 13.9L15.2 14.55M18.8 18.15L19.45 18.8M18.8 13.9L19.45 13.25M14.55 18.8L13.9 18.15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentSettings);
export default __webpack_public_path__ + "static/media/resident-settings.f67b2a317e4e7ab8c5e94c94e3149547.svg";
export { ForwardRef as ReactComponent };